import { render, staticRenderFns } from "./AssetIcon.vue?vue&type=template&id=42c01aec&"
import script from "./AssetIcon.vue?vue&type=script&lang=js&"
export * from "./AssetIcon.vue?vue&type=script&lang=js&"
import style0 from "./AssetIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports